module.exports = __webpack_public_path__ + "img/administrator.4e25789a.png";